<template>
  <div class="form-builder">
    <div v-show="showSuccessMessage" class="no-line text-left success-message-wrapper">
      <div class="success-message" v-html="successMessage"></div>
    </div>
    <div class="phone-viewport">
      <transition :name="transitionName">
        <keep-alive>
          <router-view
            class="child-view"
            :nid="nuuid"
            :mode="true"
            :content="true"
            :element="element"
            @set-tab="setTab"
            @back-to-set="backToSet"
            @back-to-go="backToGo"
            @ready-active="set_view_mode = false; go_view_mode = false;"
            @set-active="go_view_mode = false;"
            @go-active="set_view_mode = false;"
            :set-view-mode="set_view_mode"
            :go-view-mode="go_view_mode"
            :status="status"
            @change-status="status = $event"
          ></router-view>
        </keep-alive>
      </transition>

      <!-- <explore v-show="tab == 'explore'" :nid="nuuid"/>
      <try v-show="tab == 'try'" :nid="nuuid"/>
      <share v-show="tab == 'share'" :nid="nuuid"/>-->
      <div class="md-bottom-bar md-theme-default md-type-fixed" ref="bottomBar">
        <div class="md-ripple md-disabled">
          <md-button
            class="md-bottom-bar-item md-theme-default"
            :class="{'md-active': active_tab == 'ready'}"
            id="ready"
            @click="setTab('ready')"
          >
            <md-icon class="ready"></md-icon>
            <span class="md-bottom-bar-label">Ready</span>
          </md-button>
          <md-button
            class="md-bottom-bar-item md-theme-default"
            :class="{'md-active': active_tab == 'set'}"
            id="set"
            @click="setTab('set')"
          >
            <md-icon class="set"></md-icon>
            <span class="md-bottom-bar-label">Set</span>
          </md-button>
          <md-button
            class="md-bottom-bar-item md-theme-default"
            :class="{'md-active': active_tab == 'go'}"
            id="go"
            @click="setTab('go')"
          >
            <md-icon class="go"></md-icon>
            <span class="md-bottom-bar-label">Go</span>
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ready from "./views/Ready.vue";
import Set from "./views/Set.vue";
import Go from "./views/Go.vue";
import Viewer from "./views/Viewer.vue";
import CoachRubrics from "./components/CoachRubrics";
import HelpersMixin from './HelpersMixin'

export default {
  name: "Strategy",
  props: ["mode", "nid", "sid", "tab"],
  mixins: [HelpersMixin],
  created() {
    document.querySelector("body").classList.add("strategy");
    let nodes = Object.keys(window.drupalSettings.form_builder);
    if (nodes.length) {
      this.nuuid = nodes[0];
      this.$emit("set-nid", this.nuuid);
      let submissions = Object.keys(
        window.drupalSettings.form_builder[this.nuuid].submissions
      );
      submissions = submissions.filter((submission) => {
        return !!window.drupalSettings.form_builder[this.nuuid].submissions[
          submission
        ].active_tab;
      });
      if (submissions.length) {
        this.suuid = submissions[0];
      }
    }
    switch (this.$route.name) {
      default:
      case "no_tab":
        if (
          this.suuid &&
          window.drupalSettings.form_builder[this.nuuid].submissions[this.suuid]
            .active_tab
        ) {
          var activeTab =
            window.drupalSettings.form_builder[this.nuuid].submissions[
              this.suuid
            ].active_tab;
          var fieldName = "field_" + activeTab + "_form";
          let self = this;
          var submissionId = null;
          Object.keys(
            window.drupalSettings.form_builder[self.nuuid].submissions
          ).forEach((submission) => {
            if (
              window.drupalSettings.form_builder[self.nuuid].tabs[fieldName] &&
              window.drupalSettings.form_builder[self.nuuid].tabs[fieldName]
                .template &&
              window.drupalSettings.form_builder[self.nuuid].submissions[
                submission
              ].template ==
                window.drupalSettings.form_builder[self.nuuid].tabs[fieldName]
                  .template.uuid &&
              window.drupalSettings.form_builder[self.nuuid].submissions[
                submission
              ].section == ""
            ) {
              submissionId = submission;
            }
          });

          this.setTab(
            window.drupalSettings.form_builder[this.nuuid].submissions[
              this.suuid
            ].active_tab,
            false,
            true
          );

          return;
        }
        this.setTab("ready");
        break;
      case "field_ready_form":
        this.setTab("ready", true);
        break;
      case "field_set_form":
        this.setTab("set", true);
        break;
      case "field_go_form":
        this.setTab("go", true);
        break;
    }

    if (this.$route.params && this.$route.params.component) {
      let components =
        window.drupalSettings.form_builder[this.nuuid].tabs[this.$route.name]
          .data;
      components = components.filter((el) => {
        if (el.uuid == this.$route.params.component) {
          return true;
        }
      });
      if (components.length) {
        this.element = components[0];
      }
    }
  },
  mounted() {
    window.H5P.init();
    document.querySelector(".md-app").appendChild(this.$refs.bottomBar);
    //document.querySelector(".md-app .main-menu").appendChild(this.$refs.menuLeft.$el);

    this.showAssignmentMessage();
    this.clearAssignmentStorage();
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    next();
  },
  data() {
    return {
      transitionName: "slide-left",
      element: {},
      showNavigation: false,
      view_mode: this.mode || false,
      dev_mode: window.webpackHotUpdate,
      nuuid: this.nid || "",
      suuid: this.sid || "",
      active_tab: "",
      token: null,
      show_desc: true,
      id: this.$route.params.id,
      set_view_mode: false,
      go_view_mode: false,
      evaluation_type: drupalSettings.evaluation_type,
      status: null,
      showSuccessMessage: false,
      successMessage: "",
    };
  },
  components: {
    Ready,
    Set,
    Go,
    Viewer,
    CoachRubrics,
  },
  watch: {
    tab(newVal) {
      if (newVal != this.active_tab) {
        this.setTab(newVal);
      }
    },
    status(newStatus) {
      this.$emit("change-status", newStatus);
    }
  },
  methods: {
    log(data) {
      console.log(data);
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          this.token = text;
        });
    },
    setTab(tab, skipHistory, replaceHistory) {
      if (typeof replaceHistory == "undefined") {
        replaceHistory = false;
      }
      this.active_tab = tab;
      if (tab == "") {
        return;
      }
      if (!skipHistory && !replaceHistory) {
        this.$router.push("/strategy/" + this.id + "/" + this.active_tab);
      }
      if (!skipHistory && replaceHistory) {
        this.$router.replace("/strategy/" + this.id + "/" + this.active_tab);
      }
      this.sendActivity(tab);
      window.dispatchEvent(new Event("resize"));
      setTimeout(() => {
        let height = document.querySelector(".fb-welcome")
          ? document.querySelector(".fb-welcome").offsetHeight
          : 0;
        document.querySelector(".md-app-scroller").style.paddingTop =
          height + "px";
      }, 300);
      if (document.querySelector(".md-app-scroller")) {
        document.querySelector(".md-app-scroller").scrollTop = 0;
      }
      window.scrollTop = 0;
      this.$emit("tab-change", tab);
    },
    sendActivity(tab) {
      let self = this;
      return this.getToken().then(() => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", self.token);
        let method = self.suuid && self.suuid != "" ? "PATCH" : "POST";
        let a_data = {
          data: {
            type: "activity_submission--activity_submission",
            attributes: {
              data: JSON.stringify({ active_tab: tab }),
              submission_type: self.$submission_type.SUBMISSION_TYPE_TEMP,
              section:
                this.$route.name == "no_tab"
                  ? "field_ready_form"
                  : this.$route.name,
            },
            relationships: {
              activity: {
                data: {
                  type: "node--activity",
                  id: self.nuuid,
                },
              },
            },
          },
        };

        let entity_uuid = "";
        if (method == "PATCH") {
          a_data.data.id = this.suuid;
          entity_uuid = "/" + this.suuid;
        }

        return fetch(
          "/jsonapi/activity_submission/activity_submission" + entity_uuid,
          {
            credentials: "include",
            method: method,
            headers: fetch_headers,
            body: JSON.stringify(a_data),
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            if (json && json.errors && json.errors.length) {
              throw new Error(json.errors[0].title);
            }
            if (json.data && json.data.id) {
              self.suuid = json.data.id;
              self.status = json.data.attributes.status_code;
            }
            return json;
          });
      });
    },
    backToSet() {
      this.set_view_mode = true;
      this.$router.push("/strategy/" + this.id + "/set");
    },
    backToGo() {
      this.go_view_mode = true;
      this.$router.push("/strategy/" + this.id + "/go");
    },
  },
};
</script>

<style lang="scss">
// body {
//   .md-app.md-fixed .md-app-scroller {

//     @media all and (max-width: $breakpoint-medium) {
//       margin-bottom: 56px;
//     }
//   }
// }
.md-bottom-bar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 5;
  //margin-top: -56px;

  @media all and (min-width: $breakpoint-medium) {
    display: none;
  }
}

.md-bottom-bar > .md-ripple {
  justify-content: center;
}
</style>
<style lang="scss" >
.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition ease;
  transition: opacity var(--transition) ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.child-view {
  width: 100%;
  position: relative;
  transition: all $transition cubic-bezier(0.55, 0, 0.1, 1);
  transition: all var(--transition) cubic-bezier(0.55, 0, 0.1, 1);
}

.slide-right-leave-active {
  position: absolute;
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}

.slide-left-enter {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active {
  position: absolute;
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}

.startegy-menu {
  .md-icon.md-icon-font {
    background-repeat: no-repeat;
    background-position: center center;
  }
  .ready {
    background-image: url(./assets/Ready/ready_inactive_white.svg);
  }
  .set {
    background-image: url(./assets/Set/set_inactive_white.svg);
  }
  .go {
    background-image: url(./assets/Go/go_inactive_white.svg);
  }

  .active {
    a {
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
    }
    .ready {
      background-image: url(./assets/Ready/ready_active.svg);
    }
    .set {
      background-image: url(./assets/Set/set_active.svg);
    }
    .go {
      background-image: url(./assets/Go/go_active.svg);
    }
  }
}
.success-message {
  display: block!important;
}
</style>
